import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../../Navbar";
import { getData, postData, putData } from "../../../services/library";
import { Box, Container, Grid, Typography, Button, InputLabel, TextField } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import ConfirmDialog from '../../Dialogs/ConfirmDialog';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { logEventos } from "../../../services/services";
import moment from "moment";

export default function Periodos(props) {
    const globalTheme = useTheme();
    const iconConfirm = <ThumbUpIcon sx={{ fontSize: 40 }} />;
    const iconRemove = <RemoveCircleOutlineIcon sx={{ fontSize: 40 }} />;
    const [periodo, setPeriodo] = useState([]);
    const [nuevoPeriodo, setNuevoPeriodo] = useState(false);
    const [tabla, setTabla] = useState(true);
    const [periodoActual, setPeriodoActual] = useState(null);
    const [cerrarPeriodo, setCerrarPeriodo] = useState(false);
    const [datosForm, setDatosForm] = useState({});
    const [data, setData] = useState({
        mes: null,
        año: null,
        usuario: localStorage.getItem('user'),
        abierto: 1,
        codigo: null
    });
    const [notify, setNotify] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });
    const monthValue = data.año && data.mes ? `${data.año}-${data.mes}` : '';

    const getPeriodos = async () => {
        await getData('/periodo_contable', setPeriodo);
    };

    useEffect(() => {
        getPeriodos();
    }, [tabla, cerrarPeriodo, nuevoPeriodo]);

    useEffect(() => {
        if (periodo && periodo.length > 0) {
            const p = periodo.find((item) => item.abierto === 1);
            setPeriodoActual(p || null);
        }
    }, [periodo]);

    const almacenar = (e) => {
        const [año, mes] = e.target.value.split('-');
        const codigo = `${año}-${mes}`;
        setData({
            ...data,
            mes: mes,
            año: año,
            codigo: codigo
        });
    };

    const handleOpenModal = () => {
        setNuevoPeriodo(true);
    };

    const handleOpenCerrarPeriodo = () => {
        setCerrarPeriodo(true);
        setDatosForm(periodoActual);
    };

    async function postPeriodo(e) {
        await postData(e,
            '/periodo_contable',
            {
                mes: data.mes,
                año: data.año,
                usuario: data.usuario,
                abierto: data.abierto,
                codigo: data.codigo
            },
            setNotify,
            getPeriodos(),
            logEventos("Nuevo periodo contable", "Periodos", "Settings", localStorage.getItem('user'))
        );
    }

    async function updateEstado(e) {
        if (!datosForm.idperiodo_contable) {
            console.error("datosForm.idperiodo_contable es undefined");
            return;
        }

        await putData(e,
            '/periodo_contable/' + datosForm.idperiodo_contable,
            {
                abierto: 0,
                usuario: localStorage.getItem('user')
            },
            setNotify,
            getPeriodos(),
            setPeriodoActual(null),
            logEventos("Cerrar periodo contable", "Periodos", "Settings", localStorage.getItem('user'))
        );
    }

    const columns = useMemo(() =>
        [{ header: 'Nro periodo', accessorKey: 'idperiodo_contable', enableEditing: false },
        { header: 'Mes', accessorKey: 'mes', required: false, type: 'numeric' },
        { header: 'Año', accessorKey: 'año', enableEditing: false },
        { header: 'Código', accessorKey: 'codigo', enableEditing: false },
        { header: 'Estado', accessorFn: (pc) => pc.abierto === 0 ? "Cerrado" : "Abierto", type: 'numeric', required: true }
        ], []);

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary,
                    info: {
                        main: "rgb(255,122,0)"
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000"
                    }
                },
                typography: {
                    button: {
                        textTransform: "none",
                        fontSize: "1rem"
                    }
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem"
                            }
                        }
                    }
                }
            }), [globalTheme]);

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black"
        }
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 5 }
    };


    return (
        <>
            <Navbar />
            <Container>
                <Box sx={{ flexGrow: 1, backgroundColor: "#1F618D", mt: props.pt ?? 2 }}>
                    <Grid container p={1} justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <Typography variant="h5" color="#fff" textAlign="center">
                                Periodos contables
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Box display="flex">
                    {periodoActual && (
                        <Box flex={0.5} p={1} mr={1} mt={1} display="flex" flexDirection="column" sx={{ border: '2px solid grey' }}>
                            <InputLabel>Periodo contable actual</InputLabel>
                            <TextField
                                type="month"
                                focused
                                fullWidth
                                value={moment(`${periodoActual.año}-${periodoActual.mes}`, "YYYY-MM").format("YYYY-MM")}
                                readOnly
                            />
                            <Grid mt={2} container direction="row" justifyContent="space-between" alignItems="center">
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => handleOpenCerrarPeriodo(periodoActual)}
                                >
                                    Cerrar Periodo
                                </Button>
                            </Grid>
                        </Box>
                    )}

                    {!periodoActual && (
                        <Box flex={0.5} p={1} sx={{ border: '2px solid grey' }} mt={1}>
                            <InputLabel>Nuevo periodo contable</InputLabel>
                            <TextField
                                type="month"
                                focused
                                fullWidth
                                value={monthValue}
                                onChange={almacenar}
                            />
                            <Grid mt={1} container direction="row" alignItems="center">
                                <Button
                                    disabled={data.mes === null}
                                    variant="contained"
                                    onClick={handleOpenModal}
                                >
                                    Abrir nuevo periodo contable
                                </Button>
                            </Grid>
                        </Box>
                    )}
                </Box>

                <Box mt={2} boxShadow={3}>
                    {tabla && periodo ? (
                        <ThemeProvider theme={tableTheme}>
                            <MaterialReactTable
                                enableColumnResizing
                                columns={columns}
                                data={periodo}
                                muiTableHeadCellProps={tableHeadCellProps}
                                localization={MRT_Localization_ES}
                                muiTableBodyCellProps={({ row }) => ({
                                    align: "left",
                                    sx: {
                                        backgroundColor: "#ffffff",
                                        color: "black",
                                        borderColor: "black"
                                    },
                                })}
                                enableDensityToggle={false}
                                layoutMode="grid"
                                enableExpandAll={false}
                                enableToolbarInternalActions={true}
                                editingMode="row"
                                enableFullScreenToggle={false}
                                enableColumnFilters={false}
                                enableHiding={false}
                                enableColumnDragging={false}
                                positionExpandColumn='first'
                                enableTopToolbar={false}
                                enableGlobalFilter={false}
                                initialState={initialState}
                            />
                        </ThemeProvider>
                    ) : null}
                </Box>
            </Container>

            {nuevoPeriodo && (
                <ConfirmDialog
                    title={"Nuevo periodo contable"}
                    subtitle={"¿Desea abrir el nuevo periodo contable?"}
                    open={nuevoPeriodo}
                    setOpen={setNuevoPeriodo}
                    notify={notify}
                    setNotify={setNotify}
                    btnText={"Confirmar"}
                    guardar={postPeriodo}
                    color={"#2ECC71"}
                    icon={iconConfirm}
                />
            )}

            {cerrarPeriodo && (
                <ConfirmDialog
                    title={"Cerrar periodo contable"}
                    subtitle={"¿Desea cerrar el periodo contable actual?"}
                    open={cerrarPeriodo}
                    setOpen={setCerrarPeriodo}
                    notify={notify}
                    setNotify={setNotify}
                    btnText={"Confirmar"}
                    guardar={updateEstado}
                    color={"#f53649"}
                    icon={iconRemove}
                />
            )}
        </>
    );
}